export const createUsersAdapter = (user: any, presence?: string) => {
    return {
        Code: user.code,
        Name: user.name,
        Mail: user.mail,
        Active: user.active,
        Presence: presence ? presence : "Disconnect"
    }
}